import Select from '../../../../_library/Select'
import React from 'react'

export const SeatsIoSeasonEventPicker = ({seasonData, onEventChange, preselectedSeatsIoId = 'main'}) => {
  const changeEventsOptions = [
    {
      value: 'main',
      label: seasonData?.name,
    },
  ].concat(
    (seasonData?.season_events ?? []).map(data => ({
      value: data.id,
      label: data.name,
    })),
  )
  const onChange = async e => {
    const selectedEventId = e.target.value ?? null

    if (!selectedEventId) {
      return
    }

    onEventChange(selectedEventId)
  }

  return (
    <div className="seats-io-ticket-event-picker">
      <div className="col-xs-12 col-12">
        <Select
          id="SeatsIoEventPicker"
          options={changeEventsOptions}
          value={preselectedSeatsIoId ?? 'main'}
          onChange={onChange}
        ></Select>
      </div>
    </div>
  )
}